<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useMyTeamStore } from '@/stores/useMyTeamStore'
import AvatarMultiselect from '@/components/common/selects/AvatarMultiselect.vue'

type CommercialOption = { id: string; text: string; subText: string }

defineProps<{ label?: string }>()
const modelValue = defineModel<string[]>({ default: () => [] })

const myTeamStore = useMyTeamStore()
const { all, isLoaded } = storeToRefs(myTeamStore)

onMounted(() => {
  if (!isLoaded.value) myTeamStore.fetch()
})

const commercials = computed<CommercialOption[]>(() =>
  all.value
    .filter((m) => !!m.email)
    .map((m) => ({
      id: m.email,
      text: myTeamStore.memberLabel(m),
      subText: m.email,
    })),
)
</script>

<template>
  <div class="form-control w-full">
    <div v-if="label" class="label">
      <span class="label-text font-semibold">{{ label }}</span>
    </div>
    <AvatarMultiselect
      v-model="modelValue"
      :options="commercials"
      unit="commercial"
      unit-plural="commerciaux"
    />
  </div>
</template>
